import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export interface PaymentDto {
  id: string;
  amount: number;
  currency: string;
  dueDate?: string;
  itemName: string;
  status: 'paid' | 'pending' | 'overdue';
  invoiceReference?: string;
  orderId: string;
  orderUrl: string;
  isOverdue: boolean;
}

export interface PartnerPaymentDto {
  id: string;
  name: string;
  totalAmount: number;
  currency: string;
  paidAmount: number;
  pendingAmount: number;
  overdueAmount: number;
  payments: PaymentDto[];
}

export interface PaymentOverviewDto {
  paidAmount: number;
  expectedAmount: number;
  overdueAmount: number;
  currency: string;
  partners: PartnerPaymentDto[];
}

export interface PaymentOverviewFilters {
  month?: string; // YYYY-MM format or 'overall'
  status?: 'all' | 'paid' | 'pending' | 'overdue';
  partnerId?: string;
}

const PaymentsOverviewAPI = {
  /**
   * Get payment overview for all partners with optional filters
   */
  getPaymentOverview: (filters: PaymentOverviewFilters = {}) => {
    const params = new URLSearchParams();
    if (filters.month) params.append('month', filters.month);
    if (filters.status) params.append('status', filters.status);
    if (filters.partnerId) params.append('partnerId', filters.partnerId);
    
    const queryString = params.toString();
    const url = `/v1/statistics/billing/orders${queryString ? `?${queryString}` : ''}`;
    
    return APIClient(CONFIG.API_ENDPOINT).get<PaymentOverviewDto>(url);
  },

  /**
   * Get payment overview for a specific partner
   */
  getPaymentOverviewForPartner: (partnerId: string, filters: Omit<PaymentOverviewFilters, 'partnerId'> = {}) => {
    const params = new URLSearchParams();
    if (filters.month) params.append('month', filters.month);
    if (filters.status) params.append('status', filters.status);
    
    const queryString = params.toString();
    const url = `/v1/statistics/billing/orders/partners/${partnerId}${queryString ? `?${queryString}` : ''}`;
    
    return APIClient(CONFIG.API_ENDPOINT).get<PaymentOverviewDto>(url);
  }
};

export default PaymentsOverviewAPI; 